import { render, staticRenderFns } from "./ModalFreePlan.vue?vue&type=template&id=e1edc3d4&"
import script from "./ModalFreePlan.vue?vue&type=script&lang=js&"
export * from "./ModalFreePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports